import React from "react";
import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../features/api/Tasks/tasksApi";
import AddNewButton from "../AddNewButton";
import TaskItem from "./TaskItem";

export default function Tasks() {
  const { data: tasks, isLoading, isError, error } = useGetTasksQuery();
  const checkedProjects = useSelector((state) => state.projects);
  const { search } = useSelector((state) => state.search);

  const filteredTasks = tasks
    ?.filter((task) =>
      checkedProjects.some((project) => {
        return project.id === task.project.id && project.checked === true;
      })
    )
    .filter((task) => {
      return task.taskName.toLowerCase().includes(search.toLowerCase());
    });

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <div className="lws-task-list">Loading...</div>;
  } else if (!isLoading && isError) {
    content = (
      <li className="m-2 text-center">
        <div className="lws-task-list">{error?.data}</div>;
      </li>
    );
  } else if (!isLoading && !isError && filteredTasks?.length === 0) {
    content = <div className="lws-task-list">No conversations found!</div>;
  } else if (!isLoading && !isError && filteredTasks?.length > 0) {
    content = filteredTasks.map((task) => {
      return <TaskItem key={task?.id} task={task} />;
    });
  }
  return (
    <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
      <AddNewButton />

      <div className="lws-task-list">{content}</div>
    </main>
  );
}
